import React from "react";

type ButtonProps = {
  text?: string;
  onClick?: () => void;
  type?: "button"|"submit"|"reset";
  disabled?: boolean;
  button_type: "primary" | "danger" | "secondary" | "outline_primary" | "outline_secondary" | "outline_danger"; // Button types
  size: "medium" | "large" | "small";
  id?: string;
  materialicon?: string;
  iconPosition?: "left" | "right";
  [key: string]: any; // Ekstra attribute'lar için
};

export const Button: React.FC<ButtonProps> = ({ iconPosition = "left", materialicon, disabled, type, id, size = "medium", button_type = "primary", text, onClick,...rest }) => {
  const buttonClass = `new_btn btn_${button_type} ${size}`;

  return (
    <button type={type ?? 'button'} id={id} className={buttonClass} disabled={disabled}{...rest} onClick={onClick}>
      {materialicon && iconPosition === "left" && <i style={{marginInlineEnd: text ? '10px' : undefined}} className="material-icons">{materialicon}</i>}
      {text}
      {materialicon && iconPosition === "right" && <i style={{marginInlineStart: text ? '10px' : undefined}} className="material-icons">{materialicon}</i>}
    </button>
  );
};
